export default __webpack_public_path__ + "static/media/close-menu.3d85afb2.svg";